/**
 * User: herbert
 * Date: 09.05.16
 * Time: 18:10
 */

// the whole app is presentation only so we disable jsx-ally
/* eslint jsx-a11y/onclick-has-role: 0 */
/* eslint jsx-a11y/img-has-alt: 0 */


import React from 'react';

import finishActions from '../actions/finish-actions.js';

export default React.createClass({
	propTypes: {
		color: React.PropTypes.object.isRequired,
		apply: React.PropTypes.bool
	},
	_onClick: function () {
		finishActions.select(this.props.color);
		if (this.props.apply) {
			finishActions.apply();
		}
	},
	render: function () {
		return <div className={'slx-finish__field slx-finish__' + this.props.color.id} onClick={this._onClick} />;
	}
});
